import { Component, ElementRef, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { LogEvent } from 'src/app/interfaces/log';
import { MyMbtiGuestQuizReport, MyMbtiHostQuizReport } from 'src/app/interfaces/mbti';
import { LogService } from 'src/app/services/log/log.service';
import { ModalService } from 'src/app/services/modal/modal.service';
import { QuizService } from 'src/app/services/quiz/quiz.service';
import { SnackbarService } from 'src/app/services/snackbar/snackbar.service';

@Component({ template: '' })
export abstract class QuizReportSelectorComponent implements OnInit {

  @Input() hideButton = false;
  @Output() abstract selected: EventEmitter<MyMbtiHostQuizReport | MyMbtiGuestQuizReport>;
  abstract title: string;
  abstract description: string;
  abstract quizReportList: MyMbtiHostQuizReport[] | MyMbtiGuestQuizReport[];
  abstract selectedQuizReport: MyMbtiHostQuizReport | MyMbtiGuestQuizReport | undefined;
  protected cursor: string | null = null;
  protected isLoading = false;

  constructor(
    protected quizService: QuizService,
    protected snackbarService: SnackbarService,
    protected modalService: ModalService,
    protected elementRef: ElementRef,
    protected logService: LogService,
  ) { }

  ngOnInit(): void {
    this.getQuizReportList();
  }

  onClickButton(): void {
    this.logService.eventLogging(LogEvent.MBTI_SELECT_MODAL_SUBMIT_CLICKED, { from: location.pathname });
    this.modalService.dismiss(this.selectedQuizReport);
  }

  onScroll($event: Event): void {
    const scrollElem: HTMLElement = this.elementRef.nativeElement.querySelector('.quiz-select-container');
    const scrollTop = scrollElem.scrollTop;
    const offsetHeight = scrollElem.offsetHeight;
    const scrollHeight = scrollElem.scrollHeight;
    if (!this.isLoading && this.cursor !== null && (scrollHeight <= scrollTop + offsetHeight + 300)) {
      this.getQuizReportList();
    }
  }

  protected abstract onSelected(quizReport: MyMbtiHostQuizReport | MyMbtiGuestQuizReport): void;
  protected abstract getQuizReportList(): void;
  
}
